/* ============================================================================
   Mission language (PLAN §10A). A tenant setting: ON (default) = mission words,
   OFF = neutral words. Components must never hard-code "task" or "mission";
   use terms(tenant.missionLanguage).<key>.
   ========================================================================== */
export const terms_mission = {
    item: 'mission',
    items: 'missions',
    Item: 'Mission',
    Items: 'Missions',
    newItem: 'New mission',
    createItem: 'Create mission',
    addItem: 'Add mission',
    untitledItem: 'Untitled mission',
    itemId: 'Mission ID',
    subItem: 'objective',
    subItems: 'objectives',
    addSubItem: 'Add objective',
    myItems: 'My Missions',
    home: 'Mission Control',
    crew: 'Crew',
    closedGroup: 'Accomplished',
    showClosed: 'Show accomplished',
    itemCompleted: 'Mission accomplished',
    projectCompleted: 'Project complete',
    projectCompletedSub: 'All missions accomplished',
    emptyList: 'No missions here yet — create the first one',
    allDone: 'All missions accomplished. Nice work.',
    tMinusDates: true,
};
export const terms_neutral = {
    item: 'task',
    items: 'tasks',
    Item: 'Task',
    Items: 'Tasks',
    newItem: 'New task',
    createItem: 'Create task',
    addItem: 'Add task',
    untitledItem: 'Untitled task',
    itemId: 'Task ID',
    subItem: 'subtask',
    subItems: 'subtasks',
    addSubItem: 'Add subtask',
    myItems: 'My Work',
    home: 'Home',
    crew: 'Members',
    closedGroup: 'Done',
    showClosed: 'Show done',
    itemCompleted: 'Task completed',
    projectCompleted: 'Project complete',
    projectCompletedSub: 'All tasks complete',
    emptyList: 'No tasks here yet — create the first one',
    allDone: 'All tasks complete. Nice work.',
    tMinusDates: false,
};
/** `terms.mission` / `terms.neutral` plus a picker. */
export const terms = {
    mission: terms_mission,
    neutral: terms_neutral,
    for: (missionLanguage) => (missionLanguage ? terms_mission : terms_neutral),
};
//# sourceMappingURL=terms.js.map